import styled from "styled-components";

export const Wrap = styled.div`
  background: #111111;
  padding: 24px 32px;
`;
